import { render, staticRenderFns } from "./BenefitBox.vue?vue&type=template&id=6f78c8e8&scoped=true&"
import script from "./BenefitBox.vue?vue&type=script&lang=js&"
export * from "./BenefitBox.vue?vue&type=script&lang=js&"
import style0 from "./BenefitBox.vue?vue&type=style&index=0&id=6f78c8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78c8e8",
  null
  
)

export default component.exports